import { APIHandler } from "../apiHandler";

// https://github.com/jupyter/notebook/blob/master/notebook/services/config/handlers.py
class ConfigHandler extends APIHandler {
  async get({ configName }: { configName: string }) {
    this.setHeader("Content-Type", "application/json");
    const response =
      configName === "notebook"
        ? {
            load_extensions: {
              "bqplot/extension": true,
              "nbdime/index": true,
              "plotlywidget/extension": true,
              "jupyter-js-widgets/extension": true,
              "nbpresent/js/nbpresent.min": false,
              "nb_conda/main": false,
            },
          }
        : [];
    this.finish(response);
  }
}

export const defaultHandlers: [string, typeof APIHandler][] = [
  ["/api/config/:configName", ConfigHandler],
];
